export default "__VITE_ASSET__e6f113fd__"